import { useContext, useEffect } from "react";
import ConfirmApiContext from "../../contexts/confirmApi";

/**
 *
 * @param action {object}
 * @param loading {boolean}
 * @returns {(function(): void)|*}
 */
export default function useConfirmation(action, loading = undefined) {
  const [, confirmApiDispatcher] = useContext(ConfirmApiContext);

  useEffect(() => {
    if (loading) {
      confirmApiDispatcher({
        type: "start-loading",
      });
    } else {
      confirmApiDispatcher({
        type: "stop-loading",
      });
    }
  }, [loading]);

  return () => {
    confirmApiDispatcher({
      type: "confirm-action",
      title: action.title,
      onOk: action.onOk,
      message: action.message,
      loading: loading,
      async: loading !== undefined,
    });
  };
}
